import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Bar = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  border-radius: ${layout.borderRadiusFull};
  background: ${colors.lighterGrey};
  overflow: visible;
  min-height: 56px;

  @media screen and (max-width: 600px) {
    display: none;
  }
`;

export const DotSeparator = styled.span`
  color: ${colors.grey};
  margin: 0 2px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  pointer-events: none;
`;

export const CategoryWrapper = styled.div`
  display: flex;
  height: calc(100% - 8px);
  margin: 4px;
  margin-right: 0;

  @media screen and (max-width: 600px) {
    display: none;
  }
`;

export const CategoryDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 280px;
  background: ${colors.white};
  border-radius: ${layout.borderRadiusLg};
  box-shadow: ${layout.shadow};
  z-index: ${layout.zIndexDropdown};
  padding: ${space[3]};
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const DatesWrapper = styled.div<{ $isFirst?: boolean }>`
  display: flex;
  height: calc(100% - 8px);
  border-radius: ${({ $isFirst }) => ($isFirst ? '28px 0 0 28px' : '0')};
`;

export const GuestsWrapper = styled.div`
  display: flex;
  height: calc(100% - 8px);
`;

export const SearchWrapper = styled.div`
  display: flex;
  height: calc(100% - 8px);
  margin: 4px;
  margin-left: 8px;
`;

export const SearchPill = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${space[1]};
  padding: ${space[3]} ${space[5]};
  background: ${colors.primary};
  border: none;
  border-radius: ${layout.borderRadiusFull};
  color: ${colors.white};
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const SearchLabel = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: center;

  &::after {
    content: attr(data-text);
    font-weight: ${fonts.weight.semiBold};
    height: 0;
    overflow: hidden;
    visibility: hidden;
    pointer-events: none;
  }
`;

export const DropdownAnchor = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  z-index: ${layout.zIndexDropdown};
  left: 50%;
  transform: translateX(-50%);
`;

export const Pill = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${space[3]};
  background: ${({ $active }) => ($active ? colors.white : 'transparent')};
  border: none;
  cursor: pointer;
  padding: ${space[3]} ${space[5]};
  height: 100%;
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${({ $active }) => ($active ? fonts.weight.semiBold : fonts.weight.medium)};
  color: ${colors.fontPrimary};
  white-space: nowrap;
  border-radius: ${layout.borderRadiusFull};
  transition: background 0.15s ease, font-weight 0.1s ease;

  &:hover {
    font-weight: ${fonts.weight.semiBold};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;
